import NotificationsTab from "@/components/NavBar/NotificationsTab";
import {AnimatePresence, motion} from "framer-motion";
import {PanelRightClose} from "lucide-react";
import {useEffect, type FC} from "react";
import {useTranslation} from "react-i18next";

const NotificationPanel: FC<{isOpen: boolean; onClose: () => void}> = ({isOpen, onClose}) => {
  const {t} = useTranslation("notifications");

  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            transition={{duration: 0.2}}
            className="fixed inset-0 z-1100 bg-black/20"
            onClick={onClose}
          />

          <motion.aside
            initial={{x: "100%"}}
            animate={{x: 0}}
            exit={{x: "100%"}}
            transition={{type: "spring", damping: 30, stiffness: 300}}
            className="fixed top-0 right-0 z-1200 flex h-screen w-full max-w-105 flex-col border-l border-gray-100 bg-white shadow-lg">
            <div className="flex shrink-0 items-center justify-between border-b border-gray-100 px-5 py-4">
              <h2 className="text-neutral-black m-0 text-base font-semibold">{t("notifications")}</h2>
              <button
                onClick={onClose}
                className="text-neutral-grey-light hover:text-neutral-black hover:bg-neutral-white-dark flex size-8 items-center justify-center rounded-md transition-colors">
                <PanelRightClose className="size-4" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto">
              <NotificationsTab />
            </div>
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
};

export default NotificationPanel;
